import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MyDatePickerModule  } from 'mydatepicker';
import { CommonServiceService } from '../../../component/common/common-service.service';
import { ViewUsersComponent } from '../view-users/view-users.component';
import { CreateUserComponent } from '../create-user/create-user.component';
import { UserDetailComponent } from '../user-detail/user-detail.component';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { ReviewsComponent } from '../reviews/reviews.component';
import { MskComponent } from '../msk/msk.component';
import { SubscriptionComponent } from '../subscription/subscription.component';
import { DoctorSubscriptionComponent } from '../doctor-subscription/doctor-subscription.component';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { LoaderComponentUserData } from '../../../shared/component/loader-data/loader.component';
import { SubscriptionInvoiceComponent } from '../subscription-invoice/subscription-invoice.component'; 
import { UserPostComponent } from '../user-post/user-post.component'; 
import { MytransactionComponent } from '../mytransaction/mytransaction.component'; 
import { ColorPickerModule } from 'ngx-color-picker';
import {CUSTOM_ELEMENTS_SCHEMA} from  '@angular/core';
import { CKEditorModule } from 'ng2-ckeditor';
import { DonationComponent } from '../donation/donation.component';
import { MycorporateComponent } from '../mycorporate/mycorporate.component'
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MyDatePickerModule,
    ColorPickerModule, 
    CKEditorModule,
     RouterModule.forChild([
            {path : 'viewuser', component : ViewUsersComponent},
            {path : 'createuser', component : CreateUserComponent}, 
            {path : 'userupdate/:id', component : CreateUserComponent},
            {path : 'userdetail/:id', component : UserDetailComponent},
            {path : 'userdetail', component : UserDetailComponent},
            {path : 'profile/:id', component : CreateUserComponent},
            {path : 'reviews', component : MskComponent},
            {path : 'myreviews', component : ReviewsComponent},
            {path : 'mypost', component : UserPostComponent},
            {path : 'contactus', component : ContactUsComponent},
            {path : 'subscription', component : SubscriptionComponent},
            {path : 'docsubscription', component : DoctorSubscriptionComponent},
            {path : 'invoice/:id', component: SubscriptionInvoiceComponent},
            {path : 'mytransaction', component : MytransactionComponent},
            {path : 'mycorporate', component : MycorporateComponent},
            {path : 'donation', component : DonationComponent}
          ])
    
  ],
  declarations: [
    ViewUsersComponent,
    CreateUserComponent,
    UserDetailComponent,
    LoaderComponentUserData,
    UserProfileComponent,
    ReviewsComponent,
    ContactUsComponent,SubscriptionComponent,MskComponent,
    DoctorSubscriptionComponent,SubscriptionInvoiceComponent,
     UserPostComponent,MytransactionComponent,MycorporateComponent,
     DonationComponent
  ],
  providers : [CommonServiceService],
  exports: [RouterModule],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class UserRouteModule { }



// WEBPACK FOOTER //
// ./src/app/section/user/user-route/user-route.module.ts